export default "__VITE_ASSET__Bux0z0L1__"